import { Switchboard } from "../../lib/events";
import { ToolbarButton } from "../../lib/ui/toolbar/buttons";
export class ZoomToSelectedButton extends ToolbarButton {
    constructor() {
        super('compress-arrows-alt', 'Zoom to Selected Parcel(s)', 'ztsButton');
        this.emitter = Switchboard.get_emitter("CONTEXT");
    }
    _action() {
        this.emitter.emit('zoom', true);
        this.ui.removeClass('highlighted');
    }
}
export class ZoomInButton extends ToolbarButton {
    constructor() {
        super('search-plus', 'Zoom in', 'zoomInButton');
        this.zoom_change_broadcaster = Switchboard.get_emitter("MAP_ZOOM_EVENT");
    }
    _action() {
        this.zoom_change_broadcaster.emit('map_zoom_event', 'zoom-in');
        this.ui.removeClass('highlighted');
    }
}
export class ZoomOutButton extends ToolbarButton {
    constructor() {
        super('search-minus', 'Zoom out', 'zoomOutButton');
        this.zoom_change_broadcaster = Switchboard.get_emitter("MAP_ZOOM_EVENT");
    }
    _action() {
        this.zoom_change_broadcaster.emit('map_zoom_event', 'zoom-out');
        this.ui.removeClass('highlighted');
    }
}
